import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'lib-cdw-step',
  templateUrl: './cdw-step.component.html',
  styleUrls: ['./cdw-step.component.scss'],
  standalone: false,
})
export class CdwStepComponent {
  @ViewChild('contentRef') templateRef!: TemplateRef<unknown>;

  @Input() label!: string;
}
